module.exports = __webpack_public_path__ + "static/p02_letrero-f6af26ee12370adc0bdf87245a00fa78.png";